import { render, staticRenderFns } from "./ProjectAddBaseInfo.vue?vue&type=template&id=ffe67b38"
import script from "./ProjectAddBaseInfo.vue?vue&type=script&lang=js"
export * from "./ProjectAddBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports